import { IFeatureToggles } from '../../types/redux/featureToggles';

const defaultState: IFeatureToggles = {
  isDataPaymentFeatureActive: false,
  isFindAgentTabEnabled: false,
};

export const featureTogglesReducer = (state = defaultState) => {
  return state;
};
